import { formatActionLabel, formatRuleSummary } from "./format-rule-summary"

const MAX_PREVIEW_ITEMS = 2

export function buildRuleSetSummary(ruleSet, conditionFields = []) {
    const rules = ruleSet?.rules || []
    const directRules = rules.filter(isDirectRule)
    const referencedRuleSets = rules.filter(isRuleSetReference)
    const previewItems = rules.slice(0, MAX_PREVIEW_ITEMS).map(formatPreviewItem)
    const hiddenRuleCount = rules.length - previewItems.length

    if (hiddenRuleCount > 0) {
        previewItems.push(`+ ${pluralize(hiddenRuleCount, "more rule")}`)
    }

    return {
        meta: [
            formatDefaultAction(ruleSet?.defaultAction),
            pluralize(directRules.length, "rule"),
            formatReferencedRuleSetCount(referencedRuleSets.length),
        ]
            .filter(Boolean)
            .join(" | "),
        preview: previewItems.filter(Boolean).join(" | "),
    }

    function formatPreviewItem(rule) {
        if (isRuleSetReference(rule)) return formatReferencePreview(rule)
        return formatDirectRulePreview(rule, conditionFields)
    }
}

function formatDefaultAction(defaultAction) {
    if (defaultAction === "exclude") return "Exclude by default"
    return "Include by default"
}

function formatReferencedRuleSetCount(count) {
    if (!count) return null
    return pluralize(count, "included rule set")
}

function formatReferencePreview(rule) {
    const label = rule.ruleSetName || rule.ruleSetId
    if (!label) return "Rule set reference"
    return `Rule set: ${label}`
}

function formatDirectRulePreview(rule, conditionFields) {
    const action = formatActionPreview(rule.action)
    const conditions = formatRuleSummary(rule, conditionFields)
    if (conditions === "No conditions") return `${action}: all tasks`
    return `${action}: ${conditions}`
}

function formatActionPreview(action) {
    return formatActionLabel(action)
}

function isDirectRule(rule) {
    return !isRuleSetReference(rule)
}

function isRuleSetReference(rule) {
    return rule?.type === "ruleSetReference"
}

function pluralize(count, singular) {
    if (count === 1) return `${count} ${singular}`
    return `${count} ${singular}s`
}
